<template>
  <div class="error-page">
    <div class="error-container">
      <div class="error-icon">
        <svg v-if="error?.statusCode === 404" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      
      <h1 class="error-code">{{ error?.statusCode }}</h1>
      
      <h2 class="error-title">
        {{ errorTitle }}
      </h2>
      
      <p class="error-message">
        {{ error?.message || defaultMessage }}
      </p>
      
      <button @click="handleError" class="back-home-btn">
        {{ locale === 'zh' ? '返回首页' : locale === 'en' ? 'Back to Home' : 'Kembali ke Beranda' }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  error: Object
})

const { locale } = useI18n()

// 计算错误标题
const errorTitle = computed(() => {
  if (props.error?.statusCode === 404) {
    return locale.value === 'zh' ? '页面未找到' : locale.value === 'en' ? 'Page Not Found' : 'Halaman Tidak Ditemukan'
  }
  return locale.value === 'zh' ? '发生错误' : locale.value === 'en' ? 'An Error Occurred' : 'Terjadi Kesalahan'
})

// 计算默认错误信息
const defaultMessage = computed(() => {
  if (props.error?.statusCode === 404) {
    return locale.value === 'zh' 
      ? '抱歉，我们无法找到您要访问的页面。' 
      : locale.value === 'en' 
        ? "Sorry, we couldn't find the page you're looking for." 
        : 'Maaf, kami tidak dapat menemukan halaman yang Anda cari.'
  }
  return locale.value === 'zh' 
    ? '抱歉，服务器遇到了一些问题。' 
    : locale.value === 'en' 
      ? 'Sorry, something went wrong on our server.' 
      : 'Maaf, terjadi kesalahan pada server kami.'
})

// 清除错误并跳转回首页
const handleError = () => clearError({ redirect: '/' })
</script>

<style scoped lang="less">
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--gray-50, #f9fafb);
  padding: 24px;
  font-family: system-ui, -apple-system, sans-serif;
}

.error-container {
  max-width: 480px;
  width: 100%;
  text-align: center;
  background: #fff;
  padding: 48px 32px;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.error-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  
  svg {
    width: 64px;
    height: 64px;
    color: var(--gray-400, #9ca3af);
  }
}

.error-code {
  font-size: 60px;
  font-weight: 800;
  color: var(--primary, #000);
  line-height: 1;
  margin: 0 0 16px;
}

.error-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--gray-900, #111827);
  margin: 0 0 12px;
}

.error-message {
  font-size: 16px;
  color: var(--gray-600, #4b5563);
  margin: 0 0 32px;
  line-height: 1.6;
}

.back-home-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  background-color: var(--primary, #000);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: var(--primary-dark, #333);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
}
</style>